import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Button from '@material-ui/core/Button'

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import ReactAudioPlayer from 'react-audio-player';

import { api_host , api_auth} from '../../common/globals/constants';
class Audio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            range: {},
            dateRange: {
                selection: {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection',                    
                },
            },
            audio: this.props.data.setAudio,
            currentObjectiveId: this.props.data.currentObjectiveId,
            isLoading: true,
            isEmpty: false,
            audioPatternName: this.props.data.setAudio['patron']
        }
    }
    componentDidMount() {
        this.getDataFromAPI();
    } 
    getDataFromAPI = (objectiveId) => {
        
        const {currentObjectiveId, audio } = this.state
        let token = sessionStorage.getItem('key')
        let id_user = sessionStorage.getItem('user')
        
        fetch (api_host+`/reporte/general/objetivos/${currentObjectiveId}/audios_ivr/audio/?token=${token}&hash=${audio['hash_md5']}`)   
            //.then( response => response.body.getReader())     
            .then( response => response.json())
            .then( myJson =>  {                   
                                try {
                                    this.processData(myJson)   
                                            
                                } catch (error) {
                                    this.setState({
                                        dataError: true,
                                        data: null,
                                        isLoading: false
                                    });
                                }
                            });
        
    }
    processData = (externalData) => {
        /*externalData
        .read()
        .then((result) => {
            var blob = new Blob([result.value], { type: 'audio/wav' });
            var audioUrl = URL.createObjectURL(blob)
            //var audio = new Audio(audioUrl);
            //var audio = new Audio();
            //audio.src = audioUrl;
            //window.audio.play();
            var isEmpty = false
            if (blob.size == 0){
                isEmpty = true
            }
            this.setState({audioUrl: audioUrl, isLoading: false, isEmpty: isEmpty});
        });*/
        
        const byteCharacters = atob(externalData);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: 'audio/wav' });
        var audioUrl = URL.createObjectURL(blob)
        //var audio = new Audio(audioUrl);
        //var audio = new Audio();
        //audio.src = audioUrl;
        //window.audio.play();
        var isEmpty = false
        if (blob.size == 0){
            isEmpty = true
        }
        this.setState({audioUrl: audioUrl, isLoading: false, isEmpty: isEmpty});
        
    }

    handleClose = event => {

        /*if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })*/
        this.props.onClose()
    };
    
    render() {
        const {isLoading, audio, audioUrl, isEmpty, audioPatternName} = this.state
        var patternName = ''
        if (audioPatternName) {
            patternName = '_'+audioPatternName
        }
        if (!isLoading)  {
            return  <Portlet >
                        <PortletHeader style={{backgroundColor:'#525252', color:'white'}}>
                            <PortletLabel 
                                variant="h6"
                                title="Detalle audio"                                    
                            />
                            <PortletToolbar>
                                {isEmpty ?
                                    null
                                :
                                    <Button href={audioUrl}
                                        target="_blank"
                                        download={audio['paso_nombre']+patternName}>
                                        <CloudDownloadIcon style={{color:"white"}}  />
                                    </Button>
                                }
                                <IconButton 
                                    key="close" 
                                    aria-label="close" 
                                    style={{color:"white"}}
                                    onClick={this.handleClose}>
                                        <CloseIcon/>
                                </IconButton>
                            </PortletToolbar>
                        </PortletHeader >
                            <PortletHeader style={{backgroundColor:'#525252', color:'white'}}>
                                <PortletLabel 
                                        variant="h6"
                                        title={audio['paso_nombre']+patternName}   
                                        //subtitle={audio['nodo']}                                      
                                    />
                            </PortletHeader>
                        <PerfectScrollbar>
                            <PortletContent style={{backgroundColor: 'white',
                                                    //border: '2px solid #000',
                                                    //width: '50vw',
                                                    textAlign: 'center',
                                                    //height: '30vw',
                                                    position: 'relative',
                                                    overflow: 'auto'
                                                }}>
                                {isEmpty ?
                                    <Typography                                        
                                        variant="h3">                                     
                                        Audio no disponible
                                    </Typography> 
                                :<ReactAudioPlayer
                                    src={audioUrl}
                                    //autoPlay
                                    controls
                                    controlsList="nodownload"
                                />}    
                                
                            </PortletContent>
                        </PerfectScrollbar>
                    </Portlet>
                                
            
        } else {
            return <Portlet
                        
                        >
                        {/*<PortletHeader className={classes.header}>
                            <PortletLabel 
                                variant="h6"
                                title={this.props.title}
                            />
                        </PortletHeader>*/}
                            <PortletContent>
                                <div>      
                                    <Typography
                                        
                                        variant="h5">
                                        <CircularProgress
                                            variant="indeterminate"      
                                            size={24}
                                            thickness={4}                            
                                        />
                                        Cargando Información...
                                    </Typography>        
                                </div>
                        </PortletContent>
                    </Portlet>        
        }
    }
}
export default Audio;